// extracted by mini-css-extract-plugin
module.exports = {"side":"navbar_side__IYlgx","center":"navbar_center__89EbM","history":"navbar_history__L_OYz","navbar":"navbar_navbar__ppzqg"};